import { EntityDataAttribute, EntityStateData } from "types/Models/entity";

const hasFieldValue = (
  fields: EntityDataAttribute[],
  namePattern: string
): boolean => {
  const field = fields.find((f) => f.name?.includes(namePattern));
  if (!field) return false;

  const { value } = field;
  if (Array.isArray(value)) return value.length > 0;
  return Boolean(value);
};

/**
 * Returns the list of registrations still missing for a state
 * (Secretary of State / Registered Agent / Payroll).
 */
export const getMissingRegistrations = (
  stateData: EntityStateData
): string[] => {
  const missing: string[] = [];

  if (!hasFieldValue(stateData.foreign_qualified_data_attributes, "sos_number"))
    missing.push("Secretary of State");
  if (stateData.reg_agent_status !== "REGISTERED")
    missing.push("Registered Agent");
  if (
    !hasFieldValue(stateData.foreign_qualified_data_attributes, "pay_roll_sui")
  )
    missing.push("Payroll");

  return missing;
};
